<template>
  <div>
    <div v-if="reservationIdToMove" :style="isMobile ? 'margin-bottom: 47px' : ''" />

    <Header>
      Terminarz
    </Header>

    <TimetableFilters
      :value="search"
      :barbers="barbers"
      @filter-change="onFilterChange"
      @clear="clearSearch"
    />

    <div v-if="searching" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <b-table-simple v-else>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="px-1">Godz.</b-th>
          <b-th>Fryzjer</b-th>
          <b-th>Klient</b-th>
          <b-th class="px-1 text-center">Usł.</b-th>
          <b-th class="px-1 text-center">Rez.</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item, idx) in timetable_items">
          <b-tr
            v-for="(event, idx2) in item.events"
            :key="`${idx}_${idx2}`"
          >
              <b-th
                v-if="idx2 === 0" :rowspan="item.events.length"
                :variant="getTimeVariant(item.date_string)"
                :class="{'border-primary': ((idx2 === 0 && search.barberIds.length !== 1) || getTimeVariant(item.date_string) === 'primary')}"
                class="align-middle px-1 w-1"
                nowrap
              >
                {{ item.time }}
              </b-th>
              <b-td :class="{'border-primary': (idx2 === 0 && search.barberIds.length !== 1)}" nowrap>
                {{ event.barber.name }}
              </b-td>
              <b-td :class="{'border-primary': (idx2 === 0 && search.barberIds.length !== 1)}" nowrap>
                <span v-if="event.reservation && event.reservation.phone_number">
                  <b-link :href="`tel:${event.reservation.phone_number}`" class="text-dark">
                    <span v-if="event.reservation.contact">
                      {{ _.truncate(event.reservation.contact.name, {length: 10, omission: ''}) }}
                    </span>
                    <span v-else>
                      {{ _.truncate(event.reservation.phone_number, {length: 9}) }}
                    </span>
                  </b-link>
                  <span
                    v-if="event.reservation.is_new_customer"
                    class="text-success font-weight-bold"
                  >
                    *
                  </span>
                </span>
              </b-td>
              <b-td
                :class="{'border-primary': (idx2 === 0 && search.barberIds.length !== 1)}"
                class="text-center"
                nowrap
              >
                <span v-if="!event.reservation || event.reservation.is_blocked"></span>
                <span v-else-if="event.reservation.service.type_id === 1">
                  <b-icon icon="scissors" class="text-muted" />
                </span>
                <span v-else-if="event.reservation.service.type_id === 2">
                  <b-icon icon="scissors" class="text-primary" /><b-icon icon="plus" class="text-primary" />
                </span>
                <span v-else>
                  ??
                </span>
              </b-td>
              <b-td
                :class="{'border-primary': (idx2 === 0 && search.barberIds.length !== 1)}"
                class="text-center"
                nowrap
                @click="showTimetableItem(item, event)"
              >
                <span v-if="!event.reservation">
                  <b-icon icon="circle-fill" class="text-success" />
                </span>
                <span v-else-if="event.reservation.is_blocked">
                  <b-icon icon="slash-circle-fill" class="text-danger" />
                </span>
                <span v-else-if="event.reservation.is_pending">
                  <b-icon icon="hourglass-split" class="text-primary" />
                </span>
                <span v-else-if="event.reservation.is_paid">
                  <b-icon icon="check-circle" class="text-success" />
                </span>
                <span v-else-if="event.reservation.by_phone">
                  <b-icon icon="telephone" class="text-warning" />
                </span>
                <span v-else>
                  ??
                </span>
              </b-td>
            </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>

    <div v-if="reservationIdToMove" :style="!isMobile ? 'margin-bottom: 47px' : ''">
      <b-navbar type="dark" variant="warning" :fixed="isMobile ? 'top' : 'bottom'">
        <b-container class="d-flex justify-content-between">
          <div>
            Wybierz termin
          </div>
          <div>
            <b-button variant="light" size="sm" @click="reservationIdToMove=0">
              Anuluj
            </b-button>
          </div>
        </b-container>
      </b-navbar>
    </div>

    <TimetableItemModal
      ref="TimetableItemModal"
      :item="selectedTimetable.item"
      :event="selectedTimetable.event"
      :reservationIdToMove="reservationIdToMove"
      @phoneReservation="showPhoneReservation"
      @deleteReservation="showDeleteReservation"
      @reservationIdToMove="setReservationIdToMove"
    />
    <PhoneReservationModal
      ref="PhoneReservationModal"
      :services="services"
      :item="selectedTimetable.item"
      :event="selectedTimetable.event"
      :contacts="contacts"
    />
    <DeleteReservationModal
      ref="DeleteReservationModal"
      :item="selectedTimetable.item"
      :event="selectedTimetable.event"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import TimetableFilters from '@/Components/Timetable/TimetableFilters'
import TimetableItemModal from '@/Components/Timetable/ItemModal'
import PhoneReservationModal from '@/Components/Reservation/PhoneModal'
import DeleteReservationModal from '@/Components/Reservation/DeleteModal'

export default {
  layout: Layout,
  components: {
    Header,
    TimetableFilters,
    TimetableItemModal,
    PhoneReservationModal,
    DeleteReservationModal,
  },
  props: {
    services: Array,
    barbers: Array,
    reservations: Array,
    same_durations: Boolean,
    timetable_items: Array,
    filters: Object,
    contacts: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      selectedTimetable: {item: null, event: null},
      reservationIdToMove: 0,
      searching: false,
      search: {
        dateString: this.filters?.dateString || '',
        barberIds: this.filters?.barberIds || [],
      },
      refresherIntervalId: null,
    }
  },
  computed: {
    _() {
      return _
    },
  },
  methods: {
    onFilterChange(filters) {
      this.search = filters
      this.onSearch()
    },
    showTimetableItem(item, event) {
      this.selectedTimetable = {item, event}
      this.$refs.TimetableItemModal.show()
    },
    showPhoneReservation(item, event) {
      this.selectedTimetable = {item, event}
      this.$refs.PhoneReservationModal.show()
    },
    showDeleteReservation(item, event) {
      if (!event.reservation) return;
      this.selectedTimetable = {item, event}
      this.$refs.DeleteReservationModal.show()
    },
    setReservationIdToMove(val) {
      this.reservationIdToMove = val
    },
    onSearch() {
      this.searching = true
      this.doSearch()
    },
    doSearch() {
      const query = _.pickBy(this.search, (v) => !_.isEmpty(v))
      this.$inertia.get(this.route('timetables.show'), {
        ...query
      }, {
        replace: true,
        preserveState: true,
        onFinish: () => this.searching = false,
      })
    },
    clearSearch() {
      this.searching = true
      this.$inertia.get(this.route('timetables.show'), {
        remember: 'forget',
      }, {
        replace: true,
        preserveState: false,
      })
    },
    reload() {
      this.$inertia.reload({
        replace: true,
        preserveState: true,
        preserveScroll: true,
      })
    },
    startRefresher() {
      this.stopRefresher()
      this.refresherIntervalId = setInterval(() => {
        this.reload()
      }, 60 * 1000) // 1 min
    },
    stopRefresher() {
      clearInterval(this.refresherIntervalId)
      this.refresherIntervalId = null
    },
    handleVisibilityChange() {
      if (document.hidden) {
        // Stop polling while the tab is in the background
        this.stopRefresher()
      } else {
        // Refresh immediately on return, then resume polling
        this.reload()
        this.startRefresher()
      }
    },
    canEditTimetableItem(item) {
      const now = new Date
      const date = new Date(item.date_string)
      return date > now
    },
    getTimeVariant(dateString) {
      const now = new Date
      const date = new Date(dateString)
      if (now > date) return 'primary'
      return 'secondary'
    },
  },
  mounted() {
    // Poll only while the tab is visible
    if (!document.hidden) {
      this.startRefresher()
    }
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  destroyed() {
    this.stopRefresher()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>
